import React from "react";
import { Box, Typography } from "@mui/material";
import FormBuilder from "../../../Common/FormBuilder/FormBuilder";

function AchievementContent({ segment, onFormFieldChange }) {
    const canUpdate = segment?.canUpdate ?? false;

    return (
        <Box component="div">
            {segment?.items?.length > 0 &&
                segment.items.filter(({ id }) => !!id) &&
                segment.items.map((row, index) => (
                    <Box className="card-content" key={index}>
                        <Typography variant="h5" component="h3">
                            {row.title}
                        </Typography>
                        <Typography variant="body1">
                            {row.description}
                        </Typography>
                    </Box>
                ))}
            <FormBuilder
                form={segment?.form ?? []}
                canUpdate={canUpdate}
                onFieldChange={onFormFieldChange}
            />
        </Box>
    );
}

export default AchievementContent;
